import { QBR_DOCUMENT_URL_IDENTIFIER, QBR_PAGE } from 'partner360/components/QBR'

export const buildQbrDocumentOpenLink = (entryId: number): string => {
  return `/page/${QBR_PAGE}/${QBR_DOCUMENT_URL_IDENTIFIER}/${entryId}`
}
